// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3HYM6","head":"Table_head__7me1R","col":"Table_col__tSF67"};